import { useEffect, useState } from "react";

import { genericTechProSelector, useCurrentUi, useCurrentUser } from "@keepeek/commons";
import { useRecoilValue } from "recoil";

import { extractValidProfileIds, isManagerForUI, parseTechProConfig } from "../utils";

export type ProfilManagerForFrontEdit = {
  uiId: number;
  profilesId: number[];
}[];

export default function useCanAccessFrontEdit(): { hasAccess: boolean | undefined } {
  const { currentUi } = useCurrentUi();
  const { assignedGroup } = useCurrentUser();
  const rawTechPro = useRecoilValue(
    genericTechProSelector("PROFILES_WITH_FRONT_EDIT_ENABLED"),
  ) as string;
  const [hasAccess, setHasAccess] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!assignedGroup || !currentUi?.id || !rawTechPro) {
      setHasAccess(false);
      return;
    }

    let parsedTechPro: ProfilManagerForFrontEdit;
    try {
      parsedTechPro = parseTechProConfig(rawTechPro);
    } catch (e) {
      console.error("Failed to parse tech pro PROFILES_WITH_FRONT_EDIT_ENABLED", e);
      setHasAccess(false);
      return;
    }

    const rawProfileIds = extractValidProfileIds(assignedGroup);

    const canAccess = isManagerForUI(parsedTechPro, currentUi.id, rawProfileIds);
    setHasAccess(canAccess);
  }, [assignedGroup, currentUi?.id, rawTechPro]);

  return { hasAccess };
}
